module.exports = __webpack_public_path__ + "static/media/filter_list.1057e207.svg";